import React from 'react'
import loading from './../images/loading.gif'
export default function Loading({ full, show }: { full?: boolean, show?: boolean }) {
  return show ? <div className={"loading flexed fl-c " + (full ? 'full' : '')}>
    <img src={loading} alt="" style={{ opacity: .8, transform: 'scale(.8)' }} />
  </div> : <div></div>
}